import LightBoxPdf from './LightBoxPdf';

export default LightBoxPdf;
